// extracted by mini-css-extract-plugin
export default {"nestedText":"nested-text_nestedText__PRH10","semibold":"nested-text_semibold__ZenlF"};